import { Link } from "react-router-dom";
import { Activity, FileJson, Eraser } from "lucide-react";

const SUBCATEGORIES = [
  {
    key: "pipeline",
    label: "Pipeline & Triggers",
    description:
      "Per-domain change-tracking checkpoints, delta scans, and bulk ETL runs",
    href: "/dashboard/data/pipeline",
    icon: Activity,
  },
  {
    key: "stock-etl",
    label: "Stock ETL",
    description:
      "Run an ETL process for one stock, or update a whole tab: its ETL, payload, and page",
    href: "/dashboard/data/stock-etl",
    icon: FileJson,
  },
  {
    key: "purge",
    label: "Cache Purge",
    description:
      "Invalidate any page family — stocks, ETFs, experts, calendars, screeners — each by the mechanism that works for it",
    href: "/dashboard/data/purge",
    icon: Eraser,
  },
];

export default function DataIndex() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Data</h1>
        <p className="text-sm text-muted-foreground">
          Data pipeline observability, ETL triggers, and cache actions
        </p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {SUBCATEGORIES.map((sub) => {
          const Icon = sub.icon;
          return (
            <Link
              key={sub.key}
              to={sub.href}
              className="group flex flex-col rounded-xl border bg-card p-6 transition-all hover:border-primary/50 hover:shadow-lg hover:shadow-primary/5"
            >
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                <Icon className="h-6 w-6" />
              </div>
              <h3 className="mb-1 text-lg font-semibold">{sub.label}</h3>
              <p className="text-sm text-muted-foreground">{sub.description}</p>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
